import { createContext } from 'react';
import type { ConfirmOptions, ConfirmResult } from '../types';
export default createContext<{
  confirmBase: (parentId: string, options: ConfirmOptions) => Promise<ConfirmResult>;
  closeOnParentUnmount: (parentId: string) => void;
}>({
  confirmBase() {
    throw new Error('Missing ConfirmProvider');
  },
  closeOnParentUnmount() {
    // No provider, no open dialog to close.
  },
});
